import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import Checkbox from "@visiblethread/react-components/dist/components/Checkbox";
import { isEmptyDocument } from "utils/dictionarySearch";
import { getImage } from "utils";
import { checkedTypes } from "constants/types";
import { checkUncheckDocument } from "slices/discovery/actions/theme";
import {
  displayCannotUncheckReferenceDoc,
  displayNoDocumentsSelected,
} from "components/Modal/confModalTypes";
import { FILTER_TYPES } from "constants/discovery";

const DocumentHeaderItem = ({ doc, otherDocumentsIgnored }) => {
  const dispatch = useDispatch();
  const filterView = useSelector((state) => state.discovery.config.filterView);
  const filterType = useSelector((state) => state.discovery.config.filterType);
  const filterDocID = useSelector(
    (state) => state.discovery.config.filterDocID
  );

  const isGreyed = () =>
    doc.disabled ||
    doc.ignored ||
    doc.Occurrences === 0 ||
    doc?.Filter?.Occurrences === 0 ||
    doc?.Search?.Occurrences === 0 ||
    doc.Name?.toLowerCase().endsWith(".xls") ||
    doc.Name?.toLowerCase().endsWith(".xlsx") ||
    doc.Name?.toLowerCase().endsWith(".xlsm") ||
    doc.Name?.toLowerCase().endsWith(".xlsb");

  const handleCheck = () => {
    if (otherDocumentsIgnored && !doc.ignored) {
      dispatch(displayNoDocumentsSelected());
    } else if (
      filterView &&
      filterType === FILTER_TYPES.GAPS_RELATIVE_TO_A_REFERENCE_DOC &&
      filterDocID === doc.Id
    ) {
      dispatch(displayCannotUncheckReferenceDoc());
    } else {
      dispatch(checkUncheckDocument(doc.Id, !doc.ignored));
    }
  };

  return (
    <div
      className={`documents__header__item${isGreyed() ? " greyed" : ""}`}
      data-testid="document-header-item"
    >
      <Checkbox
        state={!doc.ignored ? checkedTypes.CHECKED : checkedTypes.EMPTY}
        handleChange={handleCheck}
        disabled={isEmptyDocument(doc)}
        id="doc_header_cb"
        value="doc_header_cb"
      />
      <span title={doc.Name}>{doc.Name}</span>
      <img src={getImage(doc.Name)} alt="doc-img" />
    </div>
  );
};

DocumentHeaderItem.propTypes = {
  doc: PropTypes.number,
  otherDocumentsIgnored: PropTypes.bool.isRequired,
};

const DocumentListHeader = ({ headerRef }) => {
  const documents = useSelector(
    (state) => state.discovery.themes[0]
  )?.Documents;

  const otherDocumentsIgnored = (documents, currentDoc) => {
    return documents
      ?.filter((doc) => doc.Id !== currentDoc.Id)
      .every((doc) => doc.ignored === true);
  };

  return (
    <div
      className="documents__header"
      ref={headerRef}
      data-testid="documents-header"
    >
      {documents?.map((doc) => (
        <DocumentHeaderItem
          doc={doc}
          otherDocumentsIgnored={otherDocumentsIgnored(documents, doc)}
        />
      ))}
    </div>
  );
};

export default DocumentListHeader;

DocumentListHeader.propTypes = {
  headerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
};
